import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Button } from '@material-ui/core';

class NotificationButton extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        content: PropTypes.object.isRequired
    };

    render() {
        const { content, classes } = this.props;
        return (
            <Button variant="contained" className={`${content !== undefined && classes[content.classes]} ${classes.buttons}`}>
                <i className={`fas ${content.icon} ${classes.icon}`} />
                {content.label}
            </Button>
        );
    }
}

const styles = theme => ({
    'btn-success': {
        backgroundColor: theme.palette.success.main
    },
    'btn-warning': {
        backgroundColor: theme.palette.warning.main
    },
    'btn-danger': {
        backgroundColor: theme.palette.error.main
    },
    icon: {
        marginRight: 5
    },
    buttons: {
        color: theme.palette.colors.white,
        marginRight: 4
    }
});

export default withStyles(styles, { withTheme: true })(NotificationButton);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Notification/components/NotificationButton.js